<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center navbar-col-left d-none d-lg-flex">
      <bookmarks />
    </div>

    <!-- Общий плеер: боковые колонки равны по ширине, поэтому он встаёт по центру -->
    <global-player />

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center navbar-col-right justify-content-end">
      <locale />
      <dark-Toggler class="d-none d-lg-block" />
      <search-bar />
      <cart-dropdown />
      <game-reminders-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import DarkToggler from './components/DarkToggler.vue'
import SearchBar from './components/SearchBar.vue'
import CartDropdown from './components/CartDropdown.vue'
import GameRemindersDropdown from '@/layouts/components/GameRemindersDropdown.vue'
import GlobalPlayer from '@/layouts/components/GlobalPlayer.vue'
import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    DarkToggler,
    SearchBar,
    CartDropdown,
    GameRemindersDropdown,
    GlobalPlayer,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

}
</script>

<style lang="scss" scoped>
// Боковые колонки шапки равны по ширине — плеер между ними встаёт по центру
.navbar-col-left,
.navbar-col-right {
  flex: 1 1 0;
}

.navbar-col-left {
  min-width: 0;
}

// Иконки справа не сжимаются: при нехватке места уступают закладки и плеер
.navbar-col-right {
  min-width: max-content;
}
</style>
